import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import stylesCommon from "../../common.module.scss"
import CustomButton from '../../../custom/custom-button/CustomButton';
import CustomInput from '../../../custom/custom-input/CustomInput';
import { User } from "../../../../services";
import { toast } from 'react-toastify';
import { useRegistration } from '../../../../hooks/useRegistration';
import { validateCompanyName, validateBinLength } from '../../../../utils/registrationValidation';

const SurveyUserRegistrationFirst = ({ updateStep, setData, data, code, clientId }) => {
  const { t } = useTranslation();
  const { isLoading, performRegistration } = useRegistration();
  const isKazakhstan = data?.phoneCountryCode === 'KZ';
  
  const [bin, setBin] = useState(data?.bin || '');
  const [companyName, setCompanyName] = useState(data?.companyName || '');

  const [errorTitleBin, setErrorTitleBin] = useState();
  const [errorTitleNameCompany, setErrorTitleNameCompany] = useState();

  const nextStep = async () => {
    setErrorTitleBin(null);
    setErrorTitleNameCompany(null);

    if (isKazakhstan) {
      if (!validateBinLength(bin)) {
        setErrorTitleBin(t('registrationSurveyUserFirst.validation.invalidBinLength'));
        return;
      }

      const isBinValid = await checkBin(bin);
      if (!isBinValid) {
        setErrorTitleBin(t('registrationSurveyUserFirst.validation.binExists'));
        return;
      }
    } else {
      if (!bin.trim()) {
        setErrorTitleBin(t('registrationSurveyUserFirst.bin.label'));
        return;
      }

      const isBinValid = await checkBin(bin);
      if (!isBinValid) {
        setErrorTitleBin(t('registrationSurveyUserFirst.validation.binExists'));
        return;
      }
    }

    if (!validateCompanyName(companyName)) {
      setErrorTitleNameCompany(t('registrationSurveyUserFirst.validation.companyNameRequired'));
      return;
    }

    const updatedData = {
      ...data,
      bin: bin,
      companyName: companyName,
    };

    setData(updatedData);

    // Check if type parameter exists in URL
    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get('type');
    
    if (typeParam && (typeParam.toLowerCase() === 'client' || typeParam.toLowerCase() === 'expeditor')) {
      // Type is in URL, perform registration and login
      try {
        await performRegistration(updatedData, code, clientId);
      } catch (error) {
        // Error already handled in hook
      }
    } else {
      // No type in URL, proceed to step 3 for manual selection
      updateStep(3);
    }
  };

  const checkBin = async (bin) => {
    try {
      const response = await User.check("bin", bin);
      return !response.data.isExists;
    } catch (error) {
      console.error('Error checking BIN:', error);
      return false;
    }
  };

  useEffect(() => {
    if (data.companyName) setCompanyName(data.companyName);
  }, [data]);

  return (
    <div className={stylesCommon.fullWidth}>
      <div className={stylesCommon.form}>
        <CustomInput
          placeholder="123456789012"
          labelText={t('registrationSurveyUserFirst.bin.label')}
          inputType="text"
          onChangeValue={setBin}
          value={bin}
          errorText={errorTitleBin}
          {...(isKazakhstan ? { maxLength: 12 } : {})}
          isBin
        />
        <CustomInput
          placeholder={t('registrationSurveyUserFirst.companyName.placeholder')}
          labelText={t('registrationSurveyUserFirst.companyName.label')}
          inputType="text"
          onChangeValue={setCompanyName}
          value={companyName}
          errorText={errorTitleNameCompany}
        />
      </div>
      <div className={stylesCommon.btns}>
        <CustomButton isFall isLoading={isLoading} text={t('registrationSurveyUserFirst.buttons.continue')} onClick={nextStep} />
      </div>
    </div>
  );
};

export default SurveyUserRegistrationFirst;
